import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";
import React, { useState, useEffect, useRef } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
// import { toast } from "react-toastify";
import {
  AvCheckbox,
  AvCheckboxGroup,
  AvField,
  AvForm,
} from "availity-reactstrap-validation";
import { Col, Row } from "react-bootstrap";
import { post } from "../helper/helper_api";

export default function Career() {
  const [currentData, setCurrentData] = useState({
    topic: "",
    name: "",
    company: "",
    email: "",
    contact_no: "",
    comments: "",
  });
  const [randomNum1, setRandomNum1] = useState(Math.ceil(Math.random() * 20));
  const [randomNum2, setRandomNum2] = useState(Math.ceil(Math.random() * 20));
  const [total, setTotal] = useState(randomNum1 + randomNum2);
  const [inputValue, setInputValue] = useState("");
  const [isCorrect, setIsCorrect] = useState(false);
  const captchaValue = randomNum1 + randomNum2;
  const formRef = useRef(null);

  const handleChange = (event) => {
    setInputValue(event.target.value);
    setIsCorrect(parseInt(event.target.value) === captchaValue);
  };

  const resetQuestion = () => {
    setRandomNum1(Math.ceil(Math.random() * 20));
    setRandomNum2(Math.ceil(Math.random() * 20));
    setInputValue("");
    setIsCorrect(false);
  };

  // const onValidSubmit = (e, v) => {
  //   const { name, value } = e.target;

  //   setCurrentData({ ...currentData, [name]: value });
  // };

  const handleValidSubmit = async (e, v) => {
    e.preventDefault(); // Prevent default form submission
    // Check if the input value is blank
    if (inputValue.trim() === "") {
      toast.error("Please enter a value for the captcha.");
      return; // Halt form submission
    }

    // Check if the input value matches the captcha value
    if (!isCorrect) {
      toast.error("Incorrect answer. Please try again.");
      return; // Halt form submission
    }
    let body = {
      ...v,
    };
    if (formRef.current) {
      formRef.current.reset();
    }
    post("/inquiry", body)
      .then((res) => {
        console.log("res", res);
        toast.success("Inquiry Submitted Successfully");
        setInputValue("");
      })
      .catch((error) => {
        console.log("error", error);
        console.log("Somthing went wrong!");
      });
  };
  // const notify = () => toast("Inquiry Submitted Successfully");

  return (
    <div className="slider-wrapper">
      <div className="container">
        <div className="row mt-63">
          <div className="col-sm-12">
            <div className="mainbdr whitebg">
              <div className="row">
                <div className="col-sm-3">
                  <Sidebar />
                </div>
                <div className="col-sm-9" style={{ marginTop: "5px" }}>
                  <div className="row mt-0">
                    <div className="col-sm-12">
                      <div className="inner_content contactpage enq">
                        <h2>INQUIRY</h2>
                        <div className="clearfix"></div>
                        <AvForm
                          ref={formRef}
                          className="form-horizontal"
                          onValidSubmit={(e, v) => {
                            console.log("Form data submitted:", v);
                            handleValidSubmit(e, v);
                          }}
                        >
                          <Row>
                            <Col lg={12} md={12}>
                              <div className="mb-3">
                                <AvField
                                  name="topic"
                                  className="form-control"
                                  placeholder="Enter live session url"
                                  type="select"
                                  // onChange={(e) => onValidSubmit(e, "topic")}
                                  required
                                >
                                  <option value="">Select inquiry</option>
                                  <option value="business inquiry">
                                    Business Inquiry
                                  </option>
                                  <option value="product inquiry">
                                    Product Inquiry
                                  </option>
                                </AvField>
                              </div>
                            </Col>

                            <Col lg={6} md={6}>
                              <div className="mb-3">
                                <AvField
                                  name="name"
                                  className="form-control"
                                  placeholder="Name"
                                  type="text"
                                  // onChange={(e) => onValidSubmit(e, "name")}
                                  required
                                  value={currentData?.name}
                                />
                              </div>
                            </Col>
                            <Col lg={6} md={6}>
                              <div className="mb-3">
                                <AvField
                                  name="company"
                                  className="form-control"
                                  placeholder="Company"
                                  type="text"
                                  // onChange={(e) => onValidSubmit(e, "company")}
                                  required
                                  value={currentData?.company}
                                />
                              </div>
                            </Col>
                            <Col lg={6} md={6}>
                              <div className="mb-3">
                                <AvField
                                  name="email"
                                  className="form-control"
                                  placeholder="Email"
                                  type="text"
                                  // onChange={(e) => onValidSubmit(e, "email")}
                                  required
                                  value={currentData?.email}
                                />
                              </div>
                            </Col>
                            <Col lg={6} md={6}>
                              <div className="mb-3">
                                <AvField
                                  name="contact_no"
                                  className="form-control"
                                  placeholder="Phone Number "
                                  type="text"
                                  // onChange={(e) =>
                                  //   onValidSubmit(e, "contact_no")
                                  // }
                                  required
                                  value={currentData?.contact_no}
                                />
                              </div>
                            </Col>
                            <Col lg={12} md={12}>
                              <div className="mb-3">
                                <AvField
                                  name="comments"
                                  className="form-control"
                                  placeholder="Comment "
                                  type="text"
                                  // onChange={(e) => onValidSubmit(e, "comments")}
                                  required
                                  value={currentData?.comments}
                                  style={{ height: "60px" }}
                                />
                              </div>
                            </Col>
                          </Row>
                          <div className="mt-4">
                            <Row>
                              <Col md={3}>
                                <input
                                  name="verify"
                                  id="ans"
                                  size="6"
                                  className="form-control validate[required]"
                                  type="number"
                                  value={inputValue}
                                  onChange={handleChange}
                                  placeholder="Enter your answer"
                                />
                              </Col>
                              <Col md={3}>
                                {" "}
                                <div id="question">
                                  {randomNum1} + {randomNum2} =
                                </div>
                                <div
                                  id="success"
                                  style={{
                                    display: isCorrect ? "block" : "none",
                                  }}
                                >
                                  Correct answer!
                                </div>
                                <div
                                  id="fail"
                                  style={{
                                    display: isCorrect ? "none" : "block",
                                  }}
                                >
                                  Incorrect answer, please try again.
                                </div>{" "}
                              </Col>
                              <Col md={3}>
                                <button
                                  // className="btn btn-primary w-100 waves-effect waves-light"
                                  type="submit"
                                  style={{
                                    backgroundColor: "#fff",
                                    border: "none",
                                  }}
                                  onClick={resetQuestion}
                                >
                                  {currentData ? "Update" : "Submit"}
                                  <img
                                    style={{
                                      width: "20px",
                                      height: "20px",
                                    }}
                                    src="../images/refresh1.png"
                                    class="img-responsive"
                                  />
                                </button>
                              </Col>
                              <Col md={3}>
                                <button
                                  className="btn btn-primary w-100 waves-effect waves-light"
                                  type="submit"
                                  // onClick={onValidSubmit}
                                  style={{
                                    backgroundColor: "#6fa130",
                                    border: "none",
                                  }}
                                >
                                  {currentData ? "SUBMIT" : "Add"}
                                </button>
                                <ToastContainer />
                              </Col>
                            </Row>
                          </div>
                        </AvForm>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <Footer />
            <div className="clearfix"></div>
          </div>
        </div>
      </div>
    </div>
  );
}
